/**
 * @flow
 */

// Convert a string to proper case
export const ToProperCase = sourceString =>
  sourceString.replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  )

export const replaceSpacesAndHypensInString = sourceString =>
  sourceString.replace(/-|\s/g, '')

export const combineAndConvertToLowerCase = sourceString => {
  const lowerCaseString = sourceString.toLowerCase()
  const updatedString = lowerCaseString.replace(/-|\s/g, '')
  return updatedString
}



// WEBPACK FOOTER //
// ./src/utils/StringUtils.js